import React from 'react';
import { CtaBlock } from './ui/CtaBlock';
import { OFFER_ANCHOR, PACK_IMAGE, PACK_IMAGE_ALT, PRODUCT_NAME } from '../data/content';
export function Hero() {
  return <header className="bg-navy" data-id="element-86" data-mp="ei1vfm5pk2xy">
      <div className="mx-auto max-w-3xl px-3 pb-5 pt-4 text-center sm:px-4 sm:pt-7" data-id="element-87" data-mp="9k0f38zo2hq6">
        <p className="text-xs font-extrabold uppercase tracking-wide text-wifi sm:text-sm" data-id="element-88" data-mp="4lysie31809y">
          📡 Método de aprendizaje paso a paso
        </p>
        <h1 className="mt-1 font-display text-[2rem] uppercase leading-[1.05] text-white sm:text-6xl" data-id="element-89" data-mp="128pjbgw0r365">
          El sistema completo para aprender{' '}
          <span className="bg-amarillo px-1 text-navy [box-decoration-break:clone]" data-id="element-90" data-mp="sartwq2fb0by">
            redes WiFi y cableado desde cero
          </span>
        </h1>
        <p className="mx-auto mt-2 max-w-2xl text-[0.82rem] leading-snug text-white/85 sm:text-base" data-id="element-91" data-mp="neauv0tor1k3">
          Aprende a instalar, configurar, optimizar y diagnosticar redes WiFi y
          cableadas para hogares y pequeños comercios, y prepárate para
          convertir este conocimiento en una nueva habilidad técnica — sin
          perderte entre cientos de videos, configuraciones y tutoriales.
        </p>

        <p className="mt-3 rounded-lg bg-wifi px-3 py-2 text-[0.7rem] font-extrabold uppercase leading-tight text-white sm:text-sm" data-id="element-92" data-mp="39acyeqprnqu2">
          📡 {PRODUCT_NAME} · 6 Tomos + 5 Bonos
        </p>

        <a href={OFFER_ANCHOR} aria-label="Ir a la sección de compra" className="mt-2 block overflow-hidden rounded-2xl border-[3px] border-amarillo transition-transform duration-150 ease-soft active:scale-[0.99]" data-id="element-93" data-mp="3eb91j22an8yf">
          <img src={PACK_IMAGE} alt={PACK_IMAGE_ALT} className="block w-full" data-id="element-94" data-mp="2ql69un2ak50c" />
        </a>

        <CtaBlock dark note="Acceso Digital Inmediato • Garantía de 7 Días" data-id="element-95" data-mp="2vjzpal152635" />
      </div>
    </header>;
}